"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var AncillaryItem = {
  category: _propTypes.string,
  type: _propTypes.string,
  icon: _propTypes.string,
  title: _propTypes.string,
  dimension: _propTypes.string
};
var Designator = {
  departureStation: _propTypes.string,
  arrivalStation: _propTypes.string,
  departureTime: _propTypes.string,
  arrivalTime: _propTypes.string,
  departureTimeUtc: _propTypes.string,
  arrivalTimeUtc: _propTypes.string
};
var StationDetails = {
  AirportName: _propTypes.string,
  StationName: _propTypes.string,
  CountryCode: _propTypes.string,
  CountryName: _propTypes.string
};
var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    translation: _propTypes.object,
    summaryData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      paxReferenceId: _propTypes.string.isRequired,
      paxName: _propTypes.string.isRequired,
      selectedAncillaries: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
        designator: (0, _propTypes.shape)(Designator).isRequired,
        data: (0, _propTypes.arrayOf)((0, _propTypes.shape)(AncillaryItem)).isRequired
      }))
    })).isRequired,
    stationDetails: (0, _propTypes.objectOf)((0, _propTypes.shape)(StationDetails)).isRequired,
    isMobile: _propTypes.bool
  },
  DefaultProps: {
    accessible: false,
    theme: _constant.DEFAULT_THEME,
    translation: _constant2.TRANSLATION,
    summaryData: [],
    stationDetails: {},
    isMobile: false
  }
};
exports.default = _default;